import { memo } from "react";
import Select from "react-select";
import { statusOption } from "../../../../constant";
import { useMicroServiceTotal } from "./hooks";
import { useElement, useLocale } from "../../../../hooks";
import { DashboardWidgetProps } from "../types";
export const MicroServiceTotal = memo(
  ({ data, action }: DashboardWidgetProps) => {
    const { t } = useLocale();
    const Input = useElement("Input");
    const Button = useElement("Button");
    const { applyFilters, setWidgetTitle, title, status, changeStatus, count } =
      useMicroServiceTotal({
        data,
        action,
      });

    const renderFilters = () => {
      return (
        <form onSubmit={applyFilters}>
          <Input
            onChange={setWidgetTitle}
            value={title}
            placeholder={t("widgetTitle")}
          />
          <Select
            defaultValue={status}
            onChange={changeStatus}
            options={statusOption}
            placeholder={t("selectStatus")}
          />
          <Button
            type="submit"
            className="btn btn-primary hi-check-circle"
          ></Button>
        </form>
      );
    };

    return data.configure ? (
      renderFilters()
    ) : (
      <>
        <i className="widget-icon hi-stack"></i>
        {count}
      </>
    );
  }
);
